// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*#region Blue*/
/*#endregion */
/*#region Blue-Grey*/
/*#endregion */
/*#region Red*/
/*#endregion */
/*#region Green*/
/*#endregion */
/*#region Yellow*/
/*#endregion*/
/*#region Misc*/
/*#endregion*/
:host {
  display: inline-block;
  margin-bottom: 6px;
}

.direction-filter {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  box-sizing: border-box;
  min-width: 140px;
  height: 40px;
  padding: 0 10px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: #3b5873;
  color: #9dbcda;
  transition: background-color 120ms ease, border-color 120ms ease;
}
@media (max-width: 1079px) {
  .direction-filter {
    min-width: 160px;
  }
}
@media (max-width: 599px) {
  .direction-filter {
    min-width: 180px;
  }
}
.direction-filter:hover:not(.disabled) {
  background: rgb(25.8498985801%, 38.5557809331%, 50.3853955375%);
  border-color: rgba(157, 188, 218, 0.25);
}
.direction-filter.disabled {
  background: #3f5061;
  color: #607387;
  opacity: 0.75;
  pointer-events: none;
}

.direction-option {
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: 4px 6px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 120ms ease;
}
.direction-option:hover {
  background: rgba(255, 255, 255, 0.06);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
